import { Checkbox, Form } from "antd";

const VISIBILITY_OPTIONS = ["all", "past", "current", "future"];

const toLabelCase = (v) =>
  typeof v === "string" ? v.charAt(0).toUpperCase() + v.slice(1) : "";

const VisibilitySelector = ({ selected = [], onSelect }) => {
  const handleChange = (option, checked) => {
    if (option === "all") {
      onSelect(checked ? [...VISIBILITY_OPTIONS] : []);
      return;
    }
    let updated = checked
      ? [...selected, option]
      : selected.filter((i) => i !== option);
    const nonAll = VISIBILITY_OPTIONS.filter((o) => o !== "all");
    const allChecked = nonAll.every((o) => updated.includes(o));
    if (allChecked && !updated.includes("all")) updated = [...updated, "all"];
    else if (!allChecked) updated = updated.filter((o) => o !== "all");
    onSelect(updated);
  };

  return (
    <div className="ai-kb-visibility-block">
      <span className="ai-kb-visibility-title">Visibility</span>
      <div className="ai-kb-visibility-options">
        {VISIBILITY_OPTIONS.map((option) => (
          <Form.Item
            key={option}
            className="checkbox-title-inline h-20 listing-long-checkbox mb-0"
            label={<span className="guest-ready-text">{toLabelCase(option)}</span>}
            name="is_display_arrival_and_checkout_instruction"
            labelCol={{ className: "custom-checkbox-label" }}
          >
            <Checkbox
              className="cus-checkbox-inline"
              checked={selected.includes(option)}
              onChange={(e) => handleChange(option, e.target.checked)}
            />
          </Form.Item>
        ))}
      </div>
    </div>
  );
};

export default VisibilitySelector;
